import React, {lazy, Suspense} from "react";
import { Route, Switch } from "react-router-dom";
import { ProtectedRoutes } from "./services/ProtectedRoutes";

const Login = lazy(() => import("./view/Login"));
const Layer1 = lazy(() => import("./view/Layer1"));
const Layer2 = lazy(() => import("./view/Layer2"));
const Unassigned = lazy(() => import("./view/Unassigned"));
const UnassignedNonAgent = lazy(() => import("./view/UnassignedNonAgent"));
const CustomMessage = lazy(() => import("./view/CustomMessage"));
// const Cms = lazy(() => import("./view/ContentManagement"));
// const Pictures = lazy(() => import("./view/Pictures"));
// const Add = lazy(() => import("./view/AddContent"));
// const Update = lazy(() => import("./view/UpdateContent"));

const Router = (prop) => {
    return (
        <Suspense fallback="">
            <Switch>
                <Route exact path="/" component={Login} />
                <ProtectedRoutes exact path="/layer1" component={Layer1} />
                <ProtectedRoutes exact path="/layer2" component={Layer2} />
                <ProtectedRoutes exact path="/unassigned" component={Unassigned} />
                <ProtectedRoutes exact path="/unassignednoagent" component={UnassignedNonAgent} />
                <ProtectedRoutes exact path="/custommessage" component={CustomMessage} />
                {/* <ProtectedRoutes exact path="/cms" component={Cms} />
                <ProtectedRoutes exact path="/pictures" component={Pictures} />

                <ProtectedRoutes exact path="/cms/add" component={Add} />
                <ProtectedRoutes exact path="/cms/update" component={Update} /> */}
            </Switch>
        </Suspense>
    );
} 

export default Router;